import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74862acb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=74862acb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74862acb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('C:/app/components/Components/Loader.vue').default})
